import { useEffect } from 'react';

import { useStoreBoot } from '@/api/useStoreBoot';
import { EAppleResponseType, ELoginMethods, ESessionStorageKeys } from '@/lib/enums';
import { BootData } from '@/lib/types';
import { useLoginState } from '@/state/hooks/login.state.hook';
import { useUrlHash } from '@/state/hooks/useUrlHash';
import { useUrlQuery } from '@/state/hooks/useUrlQuery';
import { webStorageUtil } from '@/state/webStorage.state.service';
import { LoginButton } from '@/components/portal-ui';

import { useTranslations } from 'next-intl';
import AppleLogin from 'react-apple-login';

export const AppleLoginButton = () => {
  const t = useTranslations();
  const { getBoot } = useStoreBoot();
  const bootData = getBoot.data as BootData;
  const { loginResponse, shouldDisableLoginButtons, loginButtonClickWrapper, setIsLoggingIn } =
    useLoginState();

  const { appleAppId, appleResponseType } = bootData?.integration?.playersAuthentication || {};

  const isAppleRedirect = useUrlQuery('apple') === 'true';
  const appleIdToken = useUrlHash('id_token');

  const appleResponseHandler = (response: any) => {
    const token = response.code || response;
    if (token) {
      const data = {
        userToken: token,
        authMethod: ELoginMethods.APPLE
      };
      webStorageUtil.remove(ESessionStorageKeys.REDIRECT_STATE);
      loginResponse(data);
    }
  };

  useEffect(() => {
    if (isAppleRedirect) setIsLoggingIn(true);
    if (appleIdToken) appleResponseHandler(appleIdToken);
  }, [isAppleRedirect, appleIdToken]);

  return (
    <AppleLogin
      clientId={appleAppId}
      redirectURI={`${window.location.href}login?apple=true`}
      responseType={
        appleResponseType === EAppleResponseType.CODE
          ? EAppleResponseType.CODE
          : EAppleResponseType.ID_TOKEN
      }
      responseMode={appleResponseType === EAppleResponseType.CODE ? 'query' : 'fragment'}
      callback={appleResponseHandler}
      render={(renderProps) => (
        <LoginButton
          variant='apple'
          callback={() => loginButtonClickWrapper(renderProps.onClick, ELoginMethods.APPLE)}
          text={t('portal.login.continueWithApple')}
          dataTestId='apple-login-button'
          isDisabled={shouldDisableLoginButtons}
          isModalMode={true}
          opacityOnDisabled={false}>
          <img src='https://media.appcharge.com/defaults/apple_icon_white.svg' alt='apple icon' />
        </LoginButton>
      )}
    />
  );
};
